// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context{
    font-family: Arial, sans-serif;
    margin: 0;
    margin-top: 10%;
    padding: 0;
}

.contextTitle{
    font-size: 25px;
    font-weight: bolder;
}

.titleSeparator {
    max-width: 30%;
    border: none; /* 기본 테두리 제거 */
    height: 2px; /* 선의 두께 */
    background-color: #a7c898; /* 선의 색상 */
    margin-top: 15px; /* 제목과 선 사이의 여백 */
}
.announcement-table {
     width: 70%;
    font-weight: normal;
     border-collapse: collapse;
     margin-top: 20px;
     margin: 40px auto;
     margin-bottom: 100px;
 }

.announcement-table th,
.announcement-table td {
    padding: 10px;
    text-align: center;
    border-bottom: 1px solid #ddd;
}

.announcement-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.announcement-table tr:hover {
    background-color: #f9f9f9;
}

.announcement-table td {
    font-size: 16px;
}

.announcement-table td a {
    color: #636363;
    text-decoration: none;
}

.announcement-table td a:hover {
    color: #272727;
    text-decoration: none;
}

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 90px;

}

.pagination-button {
    border: 1px solid #ffffff;
    padding: 10px 15px;
    margin: 0 5px;
    /*background-color: #ffffff;*/
    cursor: pointer;
    font-size: 13px;
    color: #6c757d;
}

.pagination-button.active {
    /*background-color: #c6e1fb;*/
    color: #fff;
    border: none;
}

.pagination-button:hover {
    background-color: #e2e6ea;
}
.bylaw-button {
    padding: 10px 100px;
    font-size: 16px;
    font-weight: normal;
    background-color: rgba(218, 218, 218, 0.37);
    color: rgb(53, 53, 53);
    border: none;
    margin: 1px;
    cursor: pointer;
}
.bylaw-button:hover {
    background-color: #a7c898;
    color: black;
}

.bylaw-button.active{
    background-color: #a7c898;
    color: black;
}
.post-attachment {
    margin-top: 20px;
    font-size: 16px;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.post-attachment strong {
    justify-content: center;
    margin-top: 40px;
    font-weight: bold;
    color: #555;
}

.post-attachment a {
    justify-content: center;
    margin-top: 40px;
    color: #6aaa7d;
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s ease;
}

.post-attachment a:hover {
    color: rgb(53, 53, 53); /* 링크 호버 시 색상 변화 */
}

.post-attachment span {
    color: #888;
    margin-top: 40px;
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Bylaws/styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY,EAAE,cAAc;IAC5B,WAAW,EAAE,UAAU;IACvB,yBAAyB,EAAE,UAAU;IACrC,gBAAgB,EAAE,iBAAiB;AACvC;AACA;KACK,UAAU;IACX,mBAAmB;KAClB,yBAAyB;KACzB,gBAAgB;KAChB,iBAAiB;KACjB,oBAAoB;CACxB;;AAED;;IAEI,aAAa;IACb,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,2CAA2C;IAC3C,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB,EAAE,kBAAkB;AAC9C;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".context{\n    font-family: Arial, sans-serif;\n    margin: 0;\n    margin-top: 10%;\n    padding: 0;\n}\n\n.contextTitle{\n    font-size: 25px;\n    font-weight: bolder;\n}\n\n.titleSeparator {\n    max-width: 30%;\n    border: none; /* 기본 테두리 제거 */\n    height: 2px; /* 선의 두께 */\n    background-color: #a7c898; /* 선의 색상 */\n    margin-top: 15px; /* 제목과 선 사이의 여백 */\n}\n.announcement-table {\n     width: 70%;\n    font-weight: normal;\n     border-collapse: collapse;\n     margin-top: 20px;\n     margin: 40px auto;\n     margin-bottom: 100px;\n }\n\n.announcement-table th,\n.announcement-table td {\n    padding: 10px;\n    text-align: center;\n    border-bottom: 1px solid #ddd;\n}\n\n.announcement-table th {\n    background-color: #f2f2f2;\n    font-weight: bold;\n}\n\n.announcement-table tr:hover {\n    background-color: #f9f9f9;\n}\n\n.announcement-table td {\n    font-size: 16px;\n}\n\n.announcement-table td a {\n    color: #636363;\n    text-decoration: none;\n}\n\n.announcement-table td a:hover {\n    color: #272727;\n    text-decoration: none;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    margin-bottom: 90px;\n\n}\n\n.pagination-button {\n    border: 1px solid #ffffff;\n    padding: 10px 15px;\n    margin: 0 5px;\n    /*background-color: #ffffff;*/\n    cursor: pointer;\n    font-size: 13px;\n    color: #6c757d;\n}\n\n.pagination-button.active {\n    /*background-color: #c6e1fb;*/\n    color: #fff;\n    border: none;\n}\n\n.pagination-button:hover {\n    background-color: #e2e6ea;\n}\n.bylaw-button {\n    padding: 10px 100px;\n    font-size: 16px;\n    font-weight: normal;\n    background-color: rgba(218, 218, 218, 0.37);\n    color: rgb(53, 53, 53);\n    border: none;\n    margin: 1px;\n    cursor: pointer;\n}\n.bylaw-button:hover {\n    background-color: #a7c898;\n    color: black;\n}\n\n.bylaw-button.active{\n    background-color: #a7c898;\n    color: black;\n}\n.post-attachment {\n    margin-top: 20px;\n    font-size: 16px;\n    color: #333;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n\n.post-attachment strong {\n    justify-content: center;\n    margin-top: 40px;\n    font-weight: bold;\n    color: #555;\n}\n\n.post-attachment a {\n    justify-content: center;\n    margin-top: 40px;\n    color: #6aaa7d;\n    text-decoration: none;\n    font-weight: bold;\n    transition: color 0.3s ease;\n}\n\n.post-attachment a:hover {\n    color: rgb(53, 53, 53); /* 링크 호버 시 색상 변화 */\n}\n\n.post-attachment span {\n    color: #888;\n    margin-top: 40px;\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
